// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"dd31006766--skeleton--3I4rI","bet-skeleton":"dd31006766--bet-skeleton--x5S8_","image-skeleton":"dd31006766--image-skeleton--2uTT_"};